/* eslint-disable handle-callback-err */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import PropTypes from "prop-types";
export default class Policies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acceptedPolicies: this.props.acceptedPolicies || false,
      policyLink: "",
      preferredCampus: "",
    };
  }
  static getDerivedStateFromProps(props, state) {
    if (props.preferredCampus !== state.preferredCampus) {
      return { preferredCampus: props.preferredCampus };
    } else {
      return null;
    }
  }

  componentDidMount() {
    this.setState({ preferredCampus: this.props.preferredCampus });
    fetch(`${process.env.REACT_APP_API_URL}/api/login/getPolicyLink`)
      .then((res) => res.json())
      .then((res) => {
        this.setState({ policyLink: res });
      })
      .catch((err) => this.setState({ policyLink: "#" }));
  }

  render() {
    const preferredCampus = this.state.preferredCampus;
    return (
      <div>
        <p>
          By submitting this application, I certify that all information
          provided is complete and accurate to the best of my knowledge. I
          further confirm that I have not been dismissed from any other higher
          education institution. If my enrollment status at another institution
          has been revoked due to disciplinary action, I understand the
          importance of disclosing this information on a separate sheet attached
          to this application.
        </p>
        <p>
          Additionally, I authorize the verification of all submitted documents
          — whether online or as hard copies — and grant the university full
          discretion to use them as necessary. I understand that they become the
          property of LGU and cannot be reclaimed. I acknowledge that
          withholding information or forgery of any presented documents will
          result in the rejection of my application or immediate dismissal from
          the university.
        </p>
        <p>
          Admission to LGU is contingent upon meeting the university’s admission
          and academic requirements, as well as the availability of space in its
          various majors.
        </p>
        <p>
          <input
            type="checkbox"
            value={this.state.acceptedPolicies}
            onChange={() => {
              this.props.collectState("Policies", !this.state.acceptedPolicies);
              this.setState((prevState) => ({
                acceptedPolicies: !prevState.acceptedPolicies,
              }));
            }}
            checked={this.state.acceptedPolicies}
          />{" "}
          I Agree to the Terms
        </p>
      </div>
    );
  }
}
Policies.propTypes = {
  collectState: PropTypes.func.isRequired,
  acceptedPolicies: PropTypes.bool,
  preferredCampus: PropTypes.string,
};
